import {
  GetImageQuery,
  GetImageQueryVariables,
  aws_exports,
  getImage,
  graphqlCall,
} from '@akin-home/amplify';

import { Storage } from 'aws-amplify';
import { encode } from 'base-64';
import { sha256 } from 'js-sha256';

const SERVERLESS_IMAGE_HANDLER_BASE_URL =
  'https://d1edq77xhgmbre.cloudfront.net';

const SERVERLESS_IMAGE_HANDLER_SECRET =
  '472B4B6250655368566D597133743677397A244326452948404D635166546A576E5A7234753778214125442A472D4A614E645267556B58703273357638792F42';

const bucket = aws_exports.aws_user_files_s3_bucket;

export const fetchImageFileUrlFromStorage = (
  ...[key, config]: Parameters<typeof Storage.get>
) => Storage.get(key, config);

interface FetchEditedImageParams {
  key: string;
  edits?: any;
  config?: Parameters<typeof Storage.get>[1];
}

export const fetchEditedImageFileUrl = async ({
  key,
  edits,
}: FetchEditedImageParams): Promise<string> => {
  const content = JSON.stringify({
    bucket,
    key: 'public/' + key,
    edits,
  });

  const path = '/' + encode(content);
  const signature = sha256.hmac
    .create(SERVERLESS_IMAGE_HANDLER_SECRET)
    .update(path)
    .hex();

  return `${SERVERLESS_IMAGE_HANDLER_BASE_URL}${path}?signature=${signature}`;
};

interface FetchImageURLParams {
  key: string;
  edits?: any;
  config?: Parameters<typeof Storage.get>[1];
}

export const fetchImageUrl = async (params: FetchImageURLParams) => {
  const { key, edits, config } = params;

  if (edits) {
    return await fetchEditedImageFileUrl(params);
  } else {
    return await fetchImageFileUrlFromStorage(key, config);
  }
};

export const getImageQuery = async (
  params: GetImageQueryVariables
): Promise<GetImageQuery> => (await graphqlCall(getImage, params)).data;
